import {
  differenceInCalendarDays,
  isPast,
  add,
  isWithinInterval,
} from 'date-fns'
import { useStaticQuery, graphql } from 'gatsby'

const ESTIMATED_DURATION = { hours: 1, minutes: 30 }

function useNextWebinar(withinDays: number = 0, includeRunning = false) {
  const {
    allWebinarSession: { nodes: webinars },
  } = useStaticQuery(graphql`
    query UpcomingWebinars {
      allWebinarSession(
        sort: { dateTime: ASC }
        filter: { status: { ne: "finished" } }
      ) {
        nodes {
          webinarId
          dateTime
          status
          event {
            name
            eventId
          }
        }
      }
    }
  `)

  const now = new Date()

  const matchingWebinars = webinars.reduce(
    (webinarsAcc: any[], webinar: { dateTime: string }) => {
      const webinarDate = new Date(webinar.dateTime)
      const estimatedEndDate = add(webinarDate, ESTIMATED_DURATION) // add typical webinar duration to start date

      const inProgress = isWithinInterval(now, {
        start: webinarDate,
        end: estimatedEndDate,
      })

      const daysUntilWebinar = differenceInCalendarDays(webinarDate, now)

      if ((!includeRunning && isPast(webinarDate)) || isPast(estimatedEndDate))
        return webinarsAcc

      if (withinDays && daysUntilWebinar > withinDays) return webinarsAcc

      return [
        ...webinarsAcc,
        {
          ...webinar,
          inProgress,
        },
      ]
    },
    [],
  )

  return matchingWebinars[0] || null
}

export default useNextWebinar
